// extracted by mini-css-extract-plugin
module.exports = {"templateDetails":"details_templateDetails__1vqHP","item":"details_item__3QhJG"};